import React from 'react';
export const SpecialOffer = () => {
  return <div className="w-full bg-green-900 py-12 text-white" data-id="element-178">
      <div className="max-w-6xl mx-auto px-4 md:px-8" data-id="element-179">
        <h2 className="text-2xl md:text-3xl font-bold text-center mb-6" data-id="element-180">
          Special Offer: Try Risk-Free for 90 Days
        </h2>
        <p className="text-center mb-8 max-w-3xl mx-auto" data-id="element-181">
          We're so confident The Daily Foundation Chew™ will transform your
          dog's breath (and overall health) that we offer:
        </p>
        <div className="grid md:grid-cols-4 gap-4 mb-12" data-id="element-182">
          <div className="bg-green-800 p-4 rounded-lg text-center" data-id="element-183">
            <span className="text-3xl text-amber-400 mb-2 block" data-id="element-184">✓</span>
            <span data-id="element-185">90-Day Money-Back Guarantee</span>
          </div>
          <div className="bg-green-800 p-4 rounded-lg text-center" data-id="element-186">
            <span className="text-3xl text-amber-400 mb-2 block" data-id="element-187">✓</span>
            <span data-id="element-188">Free Shipping on all orders</span>
          </div>
          <div className="bg-green-800 p-4 rounded-lg text-center" data-id="element-189">
            <span className="text-3xl text-amber-400 mb-2 block" data-id="element-190">✓</span>
            <span data-id="element-191">Save 20% with Subscribe & Save</span>
          </div>
          <div className="bg-green-800 p-4 rounded-lg text-center" data-id="element-192">
            <span className="text-3xl text-amber-400 mb-2 block" data-id="element-193">✓</span>
            <span data-id="element-194">Cancel anytime</span>
          </div>
        </div>
        <div className="text-center mb-8" data-id="element-195">
          <h3 className="text-xl font-bold mb-4" data-id="element-196">
            Limited Time: Get 20% Off Your First Order
          </h3>
          <p className="mb-6" data-id="element-197">
            Because fresh breath leads to more cuddles, more kisses, and more
            precious moments with your best friend.
          </p>
          <button className="bg-amber-600 text-white font-bold py-4 px-10 rounded-full text-xl hover:bg-amber-500 transition" onClick={() => {
          window.open('https://snoutyco.com/products/the-daily-foundation-chew', '_blank');
        }} data-id="element-198">
            Get Started Now - 20% Off
          </button>
          <p className="mt-4 text-sm opacity-80" data-id="element-199">
            Join thousands of pet parents who've discovered that the solution to
            bad breath isn't in the mouth – it's in the gut.
          </p>
        </div>
      </div>
    </div>;
};